import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-746a1bc4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "nav"
};
var _hoisted_2 = {
  class: "left"
};
var _hoisted_3 = {
  class: "header-nav"
};
var _hoisted_4 = {
  class: "title"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "span-title"
  }, "通知", -1);
});

var _hoisted_6 = {
  class: "nav-item"
};
var _hoisted_7 = {
  class: "title"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "span-title"
  }, "修谱", -1);
});

var _hoisted_9 = {
  class: "nav-item"
};
var _hoisted_10 = {
  class: "title"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "span-title"
  }, "设置", -1);
});

var _hoisted_12 = {
  class: "navbar-right"
};
import Hamburger from './components/hamburger';
import Breadcrumb from './components/breadcrumb';
import Avatar from './components/avatar.vue';
import Lang from './components/lang.vue';
export default {
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_Bell = _resolveComponent("Bell");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_badge = _resolveComponent("el-badge");

      var _component_Notebook = _resolveComponent("Notebook");

      var _component_Setting = _resolveComponent("Setting");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(Hamburger)), _createVNode(_unref(Breadcrumb))]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_badge, {
        value: 12,
        class: "nav-item"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
            class: "icon-L"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Bell)];
            }),
            _: 1
          }), _hoisted_5])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, {
        class: "icon-L"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Notebook)];
        }),
        _: 1
      }), _hoisted_8])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, {
        class: "icon-L"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Setting)];
        }),
        _: 1
      }), _hoisted_11])])])]), _createElementVNode("div", _hoisted_12, [_createVNode(Lang, {
        class: "navbar-item"
      }), _createVNode(Avatar, {
        class: "navbar-item"
      })])], 64);
    };
  }
};